<template lang="pug">
.form-tags
  .form-tags-input
    tags-input(element-id="formtags", :existing-tags="availableTags", :typeahead="autocomplete" :add-tags-on-blur="blur" :limit="limit", v-model="tags", :validate="validateTag", :add-tags-on-comma="true", :add-tags-on-space="true", :typeahead-hide-discard="true", :placeholder="placeholder")
  small(v-if="hint") {{ hint }}
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    existingTags: {
      type: Array,
      default: () => [],
    },
    validation: {
      type: RegExp,
    },
    blur: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Returns a list with all already existing tags
     * @returns {Array}
     */
    availableTags() {
      return this.$store.getters['Tags/tags'];
    },
  },
  methods: {
    /**
     * Validates a tag against a regex
     * @param {String} text
     * @returns {Boolean}
     */
    validateTag(text) {
      if (this.validation) {
        return this.validation.test(text);
      }
      return !/[^a-zA-Z0-9åäöÅÄÖæÆøØ\- ]/i.test(text);
    },
  },
  watch: {
    tags() {
      this.$emit('data', this.tags.map(t => t.value));
    },
  },
  data() {
    return {
      tags: [],
    };
  },
  mounted() {
    this.tags = this.existingTags.map(t => ({ id: t, value: t }));
  },
};
</script>

<style lang="scss">
.form-tags {
  .form-tags-input {
    background-color: #E9EBED;
    border: 1px solid #B7BDC6;
    border-radius: 5px;
    padding-top: 2px;
    padding-left: 2px;

    .tags-input-wrapper-default {
      border: 0;
      border-radius: 5px 1px 5px 1px;
      min-height: 40px;
      padding-left: 6px;

      &.active {
        border: 0;
        box-shadow: none;
      }

      .tags-input-badge-pill.tags-input-badge-selected-default {
        background-color: #DAEBFF;
        color: black;
        font-size: 16px;
        border-radius: 14px;
        height: 28px;
        line-height: 28px;
        padding: 0 24px 0 10px;

        .tags-input-remove {
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          &:after, &:before {
            background-color: #0062FF;
            width: 14px;
          }
        }
      }

      input[type="text"] {
        line-height: 28px;
        font-size: 16px;
        margin: 2px 0;
      }
    }
  }

  small {
    color: #8291A2;
    display: block;
    margin-top: 5px;
  }
}
</style>
